import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  Typography
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { API, graphqlOperation } from "aws-amplify";
import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import { IEmailVerificationPopup } from "../../../interfaces";
import { VerifyEmail } from "../../../queries";
import { RollbarErrorTracking } from "../../../utils/RollbarErrorTracking";
import "./EmailVerificationPopup.css";
import Link from "@material-ui/core/Link";
import { useSelector } from "react-redux";

const EmailVerificationPopup: React.FC<IEmailVerificationPopup> = (props: any) => {
  let timeToSetInMin = 2;
  let runningSeconds = 0;
  let runningMinutes = timeToSetInMin;
  let timeToSetInMinInSec = timeToSetInMin * 60;

  const [open, setOpen] = useState(props.emailOpenPopup);
  const [isverifydisabled, setVerifydisabled] = useState(true);
  const [otpErrorMessage, setOTPErrorMessage] = useState(false);
  const [verifyCodedisabled, setVerifyCodedisabled] = useState(true);
  const [resendlinkdisabled, setResendlinkdisabled] = useState(true);
  const [resendredlinkdisabled, setResendredlinkdisabled] = useState(false);
  const [isdisabled, setDisabled] = useState(false);
  const [minutes, setMinutes] = useState(timeToSetInMin);
  const [seconds, setSeconds] = useState(0);
  const [restarttimer, setRestarttimer] = useState(0);
  const [intervalId, setIntervalId] = useState<any>();
  const allInfo = useSelector((state: any) => state);

  const clearOTPData = () => {
    userInput.emailVerify_code = "";
    setVerifydisabled(true);
  }

  const validateAndHandleCodeChange = (evt: any) => {
    let onlyNos = evt.target.value.replace(/\D/g, "");
    handlecodeInputDirect(evt.target.name, onlyNos);
    setOTPErrorMessage(false);
  };

  const handlecodeInputDirect = (name: string, val: any) => {
    setUserInput({ [name]: val });
    if (val.length >= 6) {
      setVerifydisabled(false);
    } else {
      setVerifydisabled(true);
    }
  };

  const clearOTPTimer = () => {
    clearInterval(intervalId);
  }

  const emailVerify = () => {
    const learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken || "";
    OtpVerification(learnerToken, allInfo.common.leuId, userInput.emailVerify_code);
  };

  const emailResendCode = () => {
    setVerifyCodedisabled(true);
    setResendlinkdisabled(true);
    setResendredlinkdisabled(false);
    clearOTPTimer();
    setOTPErrorMessage(false);
    setRestarttimer(restarttimer + 1);
    const learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken || "";
    props.GenerateOTP(learnerToken, props.edgeid, props.email);
  };

  const [userInput, setUserInput] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    email: "",
    code: "",
  });

  const handleClose = () => {
    clearOTPTimer();
    setOpen(false);
    props.setPopupState(false);
  };
 
  const OtpVerification = async (learnerToken: string, userId: string, code: string) => {
    let pInfo = allInfo.peopleInformation;
    const verifyEmailOTP = API.graphql(graphqlOperation(VerifyEmail, { learnerToken, userId, code })) as Promise<any>;
    verifyEmailOTP.then(
      resp => {
        if (String(resp.data.verifyEmail).indexOf("Invalid otp")!== -1){
          setOTPErrorMessage(!otpErrorMessage);
          setOpen(true);
          props.setVerifyEmailDisabled(true);
          props.setEmailTextDisabled(false);
          props.setIsverifiedEmail(false);
        }
        else {
          handleClose();
          clearOTPTimer();
          setDisabled(true);
          setVerifydisabled(true);
          clearOTPData();
          props.setVerifyEmailDisabled(false);
          props.setEmailTextDisabled(true);
          props.setIsverifiedEmail(true);
          sessionStorage.setItem('pInfo',JSON.stringify(pInfo));
        }
      },
      error => (err: Error) => {
        RollbarErrorTracking.logErrorInRollbar(err.message, "error");
      }
    );
  }
  const handleEnterClickVerify = (evt: any) => {
    if ((evt.key) && (evt.key.toLowerCase() === "enter")) {
      if(!!!isverifydisabled){
        emailVerify();
      }     
    }
  }

  useEffect(() => {
    clearOTPTimer();
    const setTimer = setInterval(() => {
      const learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken || "";
      setMinutes(runningMinutes);
      setSeconds(runningSeconds === 60 ? 0 : runningSeconds);
      if (runningSeconds === 0) {
        if ((timeToSetInMin * 60) / 60 >= 0) {
          runningMinutes -= 1;
          runningSeconds = 60;
        }
      }
      runningSeconds -= 1;
      timeToSetInMinInSec -= 1;
      if (timeToSetInMinInSec < 0) {
        clearInterval(setTimer);
        clearOTPData();
        setOTPErrorMessage(false);
        setRestarttimer(restarttimer + 0);
        clearOTPTimer();
        setVerifyCodedisabled(false);
        setResendlinkdisabled(false);
        setResendredlinkdisabled(true);
      }
    }, 1000);
    clearOTPData();
    setIntervalId(setTimer);
    return () => clearInterval(setTimer);
  }, [restarttimer]);

  return (
    <div className="email-Verify-popup">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="intercept-page-dialog email-Verify-popup"
      >
        <div className="close-Icon">
          <CloseIcon className="close-icon-img" onClick={handleClose}></CloseIcon>
        </div>
        <DialogTitle className="jss1581" id="alert-dialog-title">
          <div className="popup-Header">
            {translate("profile_emailpopup_head")}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="timer-align">
              <button id="Timer-intercept-page" tabIndex={0} className="Timer-button" type="button">
                <span id="otp_mins">{`0${minutes}`}</span>:<span id="otp_secs">{seconds < 10 ? '0' + seconds : seconds}</span>
                <span className="jss1631"></span>
              </button>
            </div>
            {verifyCodedisabled && (
              <FormControl className="email-popup-formControl" disabled={isdisabled}>
              <Input
                autoComplete={"off"}
                id="emailVerify_code"
                className={otpErrorMessage?"otp-error":""}
                aria-describedby=""
                error={otpErrorMessage}
                value={userInput.emailVerify_code}
                onKeyPress={handleEnterClickVerify}
                name="emailVerify_code"
                fullWidth={true}
                required={true}
                placeholder=""
                onChange={evt => {
                  validateAndHandleCodeChange(evt);
                }}
                inputProps={{ 
                  maxLength: 6,
                  autocomplete: 'off',
                }}
              />
             
            </FormControl>
            )}        
          </DialogContentText>
        </DialogContent>
        <div className="email-errormessage">
        {otpErrorMessage && (
                <FormHelperText className="errorcode_message">{translate("profile_emailpopup_incorrectCode")}</FormHelperText>
              )}
        </div>

        <DialogActions>
          <div className="emailVerify-Timer">
            {resendlinkdisabled && 
             <div className="resend-link" aria-disabled={isdisabled}>
             <span className="resend_Message">{translate("profile_emailpopup_resendMessage")}</span>
             <Link href="#" aria-disabled={isdisabled}
               className="EmailLinks"
               onClick={emailResendCode}
             >
               {translate("profile_emailpopup_resendText")}
             </Link>
           </div>
            }       
            {resendredlinkdisabled && 
            <div className="resend-link-highlight" aria-disabled={isdisabled}>
            <span className="resend_Message">{translate("profile_emailpopup_resendMessage")}</span>
            <Link href="#" aria-disabled={isdisabled}
              className="EmailLinks"
              onClick={emailResendCode}
            >
              {translate("profile_emailpopup_resendText")}
            </Link>
          </div>
            }
             {resendlinkdisabled && 
            <div className="verify-btn">
              <Button type="button" variant="contained" disabled={isverifydisabled} color="primary" onClick={emailVerify}>
                <Typography variant="subtitle2">{translate("profile_emailVerifyChip")}</Typography>
              </Button>
            </div>
              }
            {resendredlinkdisabled && 
            <div className="verifybtn-btn">
              <Button type="button" variant="contained" disabled={isverifydisabled} color="primary" onClick={emailVerify}>
                <Typography variant="subtitle2">{translate("profile_emailVerifyChip")}</Typography>
              </Button>
            </div>
            }
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EmailVerificationPopup;
